module.exports = __webpack_public_path__ + "static/img/204.db45b01e.jpg";